import Image from "next/image";
import DropdownMenu from "@/components/custom-dropdown";

type MenuItem = {
  id: string;
  iconSrc: string;
  text: string;
  link?: string;
  func?: () => void;
  disabled?: boolean;
};

type HeaderUserMenuProps = Readonly<{
  isLoading: boolean;
  dashboardMenuItems: MenuItem[];
}>;

export default function HeaderUserMenu({
  isLoading,
  dashboardMenuItems,
}: HeaderUserMenuProps) {
  return (
    <>
      <Image
        src="/assets/svg/profileIcons/bell.svg"
        alt="اعلان ها"
        width={24}
        height={24}
        className="w-6 h-6 object-contain"
      />

      {isLoading ? (
        <span className="animate-spin rounded-full h-6 w-6 border-4 border-blue-500 border-t-transparent" />
      ) : (
        <DropdownMenu
          trigger={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 21.5 21.5"
              className="w-6.5 h-6.5 text-def"
              aria-hidden="true"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M20.75,10.75c0,5.52-4.48,10-10,10S.75,16.27.75,10.75,5.23.75,10.75.75s10,4.48,10,10Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M4.25,17.75l.56-.98c.44-.77,1.07-1.4,1.83-1.84.76-.44,1.63-.68,2.51-.68h3.2c.88,0,1.75.23,2.51.68.76.44,1.39,1.08,1.83,1.84l.56.98M13.5,8.25c0,.73-.29,1.43-.81,1.95-.51.51-1.21.8-1.94.8s-1.43-.29-1.94-.8c-.52-.52-.81-1.22-.81-1.95s.29-1.43.81-1.95c.51-.51,1.21-.8,1.94-.8s1.43.29,1.94.8c.52.52.81,1.22.81,1.95Z"
              />
            </svg>
          }
          items={dashboardMenuItems}
        />
      )}
    </>
  );
}
